import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import { Redirect } from 'react-router-dom'
import moment from 'moment'
import { getExpedientStatus, startExpedient } from '../../store/ducks/humanResources'

class ExpedientBtn extends Component {
  constructor(props) {
    super(props)
    this.state = {
      redirect: false,
      exitTime: null,
    }
  }

  render() {
    const { redirect, exitTime } = this.state

    const { startExpedient } = this.props

    const {
      getExpedientStatusIsLoading, getExpedientStatusError,
      expedientStatus, startExpedientIsLoading,
    } = this.props.humanResources

    if (getExpedientStatusIsLoading) return null

    if (!getExpedientStatusIsLoading && !getExpedientStatusError && expedientStatus) {
      return (
        <Button
          color="primary"
          size="sm"
          type="button"
          className="my-3 mx-3"
          onClick={() => startExpedient()}
          disabled={startExpedientIsLoading}
        >
          Iniciar expediente
        </Button>
      )
    }

    if (redirect && exitTime) {
      return (
        <Redirect
          push
          to={{
            pathname: '/recursos-humanos/encerrar-expediente',
            props: {
              exitTime,
            },
          }}
        />
      )
    }

    if (!getExpedientStatusIsLoading && !getExpedientStatusError && !expedientStatus) {
      return (
        <Button
          color="primary"
          size="sm"
          type="button"
          className="my-3 mx-3"
          onClick={() => this.setState({ exitTime: moment(), redirect: true })}
        >
          Encerrar expediente
        </Button>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({ humanResources: state.humanResources })
const mapDispatchToProps = dispatch => bindActionCreators({
  getExpedientStatus,
  startExpedient,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(ExpedientBtn)
